import { inject, injectable } from 'inversify';
import { TrackingService2, TrackingService2Symbol, createCommand } from '@/app/tracking/api';
import { EarnBadgesCommand } from '../../tracking/api'
import { BadgeStoreModule, BadgeStoreModuleSymbol } from '../../store';
import { NotificationService, NotificationServiceSymbol } from '@/app/notification/service';
import { createNotification } from '@/app/notification/api';
import { BadgeEarnedNotification } from '../../notification';

@injectable()
export class BadgesEarnedNotifier {
  constructor(
    @inject(TrackingService2Symbol)
    private trackingService: TrackingService2,
    @inject(BadgeStoreModuleSymbol)
    private store: BadgeStoreModule,
    @inject(NotificationServiceSymbol)
    private notificationService: NotificationService) {
  }

  public notify(badges: Array<{ id: string, date: Date }>) {
    if (badges.length === 0) { return; }

    const payloads = badges.map((item) => {
      const badge = this.store.badgeDescriptors.find((x) => x.id === item.id);
      if (!badge) { throw new Error(`Coding error: Badge with id ${item.id} not found`); }

      return {
        id: item.id,
        date: item.date,
        details: {
          title: badge.title,
          imageUri: badge.imageUri,
          descriptionFragment: badge.descriptionFragment,
          earnedDescriptionFragment: badge.earnedDescriptionFragment
        }
      };
    });
    
    this.trackingService.execute(createCommand<EarnBadgesCommand>('earn-badges', payloads))

    payloads.forEach(x => this.showNotification(x.details.title,
                                                x.details.earnedDescriptionFragment,
                                                x.details.imageUri))
  }

  private showNotification(name: string, description: string, imageUri: string) {
    this.notificationService.show(createNotification<BadgeEarnedNotification>(
      'badge-earned',
      {
        badge: {
          name,
          description,
          imageUri
        }
      }
    ))
  }
}
